import React from 'react';
import {
  SvgPencil,
  Flex,
  Copy,
  Stack,
  Column,
  SvgEnvelope,
  Button,
  Squish,
  Box,
} from '@grubhubprod/gh-cookbook-react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { DeprecatedCookbookCheckboxWrapper } from 'src/components/DeprecatedCookbookCheckboxWrapper/DeprecatedCookbookCheckboxWrapper';
import { ParentAdminTableCell } from 'src/components/enterprise/Parents/Admin/ParentAdminsController/ParentAdminsTable/ParentAdminTableCell/ParentAdminTableCell';
import { useSendWelcomeEmailToDiner } from 'src/common/features/DinersManagement/hooks/useSendWelcomeEmailToDiner';
import { RouterLink } from 'src/components/RouterLink/RouterLink';
import { Tooltip } from 'src/components/Tooltip/Tooltip';

export interface IParentAdminDisplayProps {
  corpId: string;
  firstName: string;
  lastName: string;
  dinerId: string;
  email: string;
}

export function ParentAdminDisplay({
  corpId,
  firstName,
  lastName,
  email,
  dinerId,
}: IParentAdminDisplayProps): JSX.Element {
  const { control } = useFormContext();
  const parentAdminDetailsLink = `/corporate/enterprise/parents/${corpId}/admin/${dinerId}`;

  const {
    sendWelcomeEmail,
    isLoading: isWelcomeEmailSending,
    sentWelcomeEmail: isWelcomeEmailSent,
  } = useSendWelcomeEmailToDiner();

  async function onClickMail() {
    sendWelcomeEmail(corpId, dinerId);
  }

  const fullName = `${lastName}, ${firstName}`;

  return (
    <Flex alignItems="center" justifyContent="space-between">
      <Flex alignItems="center" flexGrow={0}>
        <ParentAdminTableCell>
          <Flex
            alignItems="center"
            flexGrow={0}
            className="cancelMarginCheckboxLabel"
          >
            <DeprecatedCookbookCheckboxWrapper
              control={control}
              name="selectedParentAdminIds"
              id={`selectedParentAdminIds[${dinerId}]`}
              aria-label={`select group ${fullName}`}
              value={dinerId}
            />
          </Flex>
        </ParentAdminTableCell>
      </Flex>

      <Flex flex={1} alignItems="center">
        <Column tablet={6}>
          <ParentAdminTableCell>
            <Stack x="xxx-sm" className="ellipsisOverflow">
              <Copy variant="body">{fullName}</Copy>
            </Stack>
          </ParentAdminTableCell>
        </Column>
        <Column tablet={6}>
          <ParentAdminTableCell>
            <Stack x="xxx-sm" className="ellipsisOverflow">
              <Copy variant="body">{email}</Copy>
            </Stack>
          </ParentAdminTableCell>
        </Column>
      </Flex>
      <Squish inset="x-sm" flexGrow={0} width={120}>
        <Flex alignItems="center">
          <Squish inset="x-sm">
            <Tooltip
              maxWidth="290px"
              roundedContainer
              content={
                <Copy variant="body" color="invertedPrimaryText">
                  Edit
                </Copy>
              }
            >
              <Box>
                <RouterLink href={parentAdminDetailsLink}>
                  <Squish inset="x-sm">
                    <SvgPencil size="24px" aria-label="Parent admin details" />
                  </Squish>
                </RouterLink>
              </Box>
            </Tooltip>
          </Squish>
          <Tooltip
            maxWidth="290px"
            roundedContainer
            content={
              <Copy variant="body" color="invertedPrimaryText">
                Email
              </Copy>
            }
          >
            <Box>
              <Button
                isLoading={isWelcomeEmailSending}
                variant="tertiary"
                className="removeButtonPadding"
                onClick={() => onClickMail()}
                disabled={isWelcomeEmailSent}
              >
                <Squish inset="x-sm">
                  <SvgEnvelope aria-label="sendWelcomeEmail" size="24px" />
                </Squish>
              </Button>
            </Box>
          </Tooltip>
        </Flex>
      </Squish>
    </Flex>
  );
}
